import { Theme } from '../types';

export const autumnTheme: Theme = {
  name: 'autumn',
  colors: {
    gray: {
      50: '#fef8f3',
      100: '#fdede0',
      200: '#fad7bf',
      300: '#f6bb94',
      400: '#f19968',
      500: '#ed7c47',
      600: '#de632a',
      700: '#b94e20',
      800: '#953f1e',
      900: '#7a351d',
    },
    accent: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
    },
    semantic: {
      success: '#059669',
      successLight: '#d1fae5',
      error: '#dc2626',
      errorLight: '#fee2e2',
      warning: '#d97706',
      warningLight: '#fef3c7',
      info: '#0369a1',
      infoLight: '#dbeafe',
    },
    background: {
      app: '#fef8f3',
      surface: '#ffffff',
      elevated: '#ffffff',
      navbar: '#ffffff',
      sidebar: '#fdede0',
      hover: '#fdede0',
      active: '#fad7bf',
      blueprint: 'linear-gradient(135deg, #fef8f3 0%, #fad7bf 100%)',
    },
    text: {
      primary: '#7a351d',
      secondary: '#953f1e',
      tertiary: '#b94e20',
      disabled: '#f6bb94',
      inverse: '#ffffff',
      accent: '#78350f',
      onAccent: '#ffffff',
      muted: '#de632a',
    },
    border: {
      color: '#fad7bf',
      light: '#fdede0',
      medium: '#f6bb94',
    },
    button: {
      bg: '#fef8f3',
      bgHover: '#fdede0',
      bgActive: '#fad7bf',
      text: '#b94e20',
      border: '#f6bb94',
      primary: {
        bg: '#f59e0b',
        bgHover: '#d97706',
        bgActive: '#b45309',
        text: '#ffffff',
      },
      disabled: {
        bg: '#fdede0',
        text: '#f6bb94',
        border: '#fad7bf',
      },
    },
    input: {
      bg: '#ffffff',
      border: '#f6bb94',
      borderHover: '#f19968',
      borderFocus: '#f59e0b',
      text: '#7a351d',
      placeholder: '#f6bb94',
    },
    toggle: {
      bg: '#f6bb94',
      bgActive: '#f59e0b',
      thumb: '#ffffff',
    },
    executing: '#dc2626',
    focus: '#f59e0b',
    overlay: {
      light: 'rgba(122, 53, 29, 0.1)',
      medium: 'rgba(122, 53, 29, 0.2)',
      heavy: 'rgba(122, 53, 29, 0.3)',
      white: 'rgba(255, 255, 255, 0.1)',
    },
    shadow: {
      medium: 'rgba(245, 158, 11, 0.15)',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    // Legacy spacing
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '30px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    text: {
      xs: '12px',
      small: '14px',
      medium: '16px',
    },
  },
  borderRadius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    full: '9999px',
    // Legacy border radius
    small: '3px',
    medium: '8px',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(245, 158, 11, 0.05)',
    sm: '0 1px 3px 0 rgba(245, 158, 11, 0.08), 0 1px 2px -1px rgba(245, 158, 11, 0.08)',
    md: '0 4px 6px -1px rgba(245, 158, 11, 0.08), 0 2px 4px -2px rgba(245, 158, 11, 0.08)',
    lg: '0 10px 15px -3px rgba(245, 158, 11, 0.08), 0 4px 6px -4px rgba(245, 158, 11, 0.08)',
    xl: '0 20px 25px -5px rgba(245, 158, 11, 0.08), 0 8px 10px -6px rgba(245, 158, 11, 0.08)',
  },
  zIndex: {
    dropdown: 100,
    sticky: 200,
    overlay: 500,
    modal: 1000,
    toast: 2000,
    // Legacy z-index
    base: 0,
    accent: 5,
    content: 10,
    floating: 20,
  },
  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
};